'use es6';

export const ENABLED = ['enabled'];
export const SCROLL_PERCENTAGE = ['scrollPercentage'];